/**
 * IANA timezone via `Intl.DateTimeFormat`.
 *
 * Complements the server-side geo lookup: lets the backend infer region
 * when GeoIP returns null, and flag IP×TZ mismatches as VPN/proxy.
 *
 * Defensive try/catch covers exotic browsers (legacy iOS 13 quirk where
 * `resolvedOptions().timeZone` returns `''` on some locales) and the
 * theoretical case of `Intl` being unavailable.
 */
export function getTimezone(): string {
  if (typeof window === 'undefined') return ''
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ?? ''
  } catch {
    return ''
  }
}
